<template>
  <l-layout :layout="['xs12']" bottom-space>
    <div class="stats-toolbar">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$router.push({name: 'ViolationHistory'})">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span>返回违章日志</span>
      </v-tooltip>
      <h2 class="title">单位预约违章统计</h2>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="preset" class="period-presets">
        <v-btn flat :value="7" @click="setPreset(7)">近7天</v-btn>
        <v-btn flat :value="30" @click="setPreset(30)">近30天</v-btn>
        <v-btn flat :value="90" @click="setPreset(90)">近90天</v-btn>
      </v-btn-toggle>
    </div>

    <v-layout row wrap align-center class="stats-filters">
      <v-flex xs12 sm6 md5>
        <l-select-datetime-duration
          v-model="period"
          :max-duration-day="93"
          label="违章时间"
          @input="preset = null"
        ></l-select-datetime-duration>
      </v-flex>
      <v-flex xs12 sm4 md4>
        <v-autocomplete
          v-model="selectedOrgId"
          :items="orgOptions"
          :filter="orgFilter"
          item-text="name"
          item-value="id"
          label="预约人二级单位"
          clearable
          hide-no-data
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm2 md3 class="stats-commands">
        <v-btn color="primary" :loading="loading" :disabled="exporting" @click="loadSummary">查询</v-btn>
        <v-btn flat color="primary" :disabled="loading || exporting || !summaryRows.length" @click="exportSummary">导出汇总</v-btn>
        <v-btn flat color="primary" :loading="exporting" :disabled="loading || !summaryRows.length" @click="exportAllDetails">导出全部单位清单</v-btn>
      </v-flex>
    </v-layout>

    <div class="caption grey--text mb-2">仅含历史表中已确认的单位预约违章记录。</div>
    <v-data-table
      :headers="summaryHeaders"
      :items="summaryRows"
      :loading="loading"
      :rows-per-page-items="[10, 20, 50]"
      no-data-text="该时段没有符合条件的违章记录"
      class="elevation-0"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.orgName }}</td>
          <td class="text-xs-right">{{ props.item.violationCount }}</td>
          <td class="text-xs-right">{{ props.item.vehicleCount }}</td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn slot="activator" icon @click="selectOrg(props.item)">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
              <span>查看违章清单</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <l-data-table
      v-if="selected"
      :key="selected.orgId + ':' + request.startTime + ':' + request.endTime"
      ref="details"
      :headers="detailHeaders"
      :get-data-func="getDetails"
      no-data-text="没有违章记录"
      hide-title-search
      class="mt-4"
      clickable
      @click:row="goDetails"
    >
      <template slot="title">
        <span class="pl-2 pr-4">{{ selected.orgName }}（{{ selected.violationCount }}次）</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="objectCode"
          label="精确车牌"
          clearable
          single-line
          hide-details
          class="plate-search"
          @keyup.enter="applyPlate"
        ></v-text-field>
        <v-btn flat color="primary" @click="applyPlate">筛选</v-btn>
        <v-btn flat color="primary" :loading="exporting" :disabled="loading" @click="exportDetails">导出清单</v-btn>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LSelectDatetimeDuration from '../../../ladmin/components/LSelectDuration/LSelectDatetimeDuration'
import {time} from '../../../ladmin/utils/time'

export default {
  name: 'AppointmentOrgViolationStatistics',
  components: {LDataTable, LSelectDatetimeDuration},
  data () {
    return {
      preset: 7,
      period: {},
      request: null,
      selectedOrgId: null,
      orgOptions: [],
      summary: [],
      selected: null,
      objectCode: '',
      appliedObjectCode: '',
      queryVersion: 0,
      loading: false,
      exporting: false,
      summaryHeaders: [
        {text: '预约人二级单位', value: 'orgName'},
        {text: '违章次数', value: 'violationCount', align: 'right'},
        {text: '去重车牌数', value: 'vehicleCount', align: 'right'},
        {text: '', value: 'action', sortable: false, align: 'center'}
      ],
      detailHeaders: [
        {text: '车辆号牌', value: 'objectCode', sortable: false},
        {text: '违章时间', value: 'violationTime', sortable: false},
        {text: '违章类型 ID', value: 'viogrpId', sortable: false},
        {text: '预约人 ID', value: 'interviewerId', sortable: false},
        {text: '违章详情', value: 'description', sortable: false, maxWidth: '24em', tooltip: true}
      ]
    }
  },
  computed: {
    summaryRows () {
      const names = new Map(this.orgOptions.map(org => [org.id, org.name]))
      return this.summary.map(row => ({...row, orgName: names.get(row.orgId) || row.orgId}))
    }
  },
  watch: {
    selectedOrgId () {
      this.queryVersion++
      this.loading = false
      this.summary = []
      this.selected = null
    }
  },
  methods: {
    orgFilter (item, query, name) {
      const search = (query || '').trim().toLocaleLowerCase()
      return !!search && String(name || '').toLocaleLowerCase().includes(search)
    },
    setPreset (days) {
      const end = new Date()
      end.setHours(0, 0, 0, 0)
      end.setDate(end.getDate() + 1)
      const start = new Date(end)
      start.setDate(start.getDate() - days)
      this.preset = days
      this.period = {
        startDatetime: time.dateToStr(start, '%Y-%m-%d %H:%M:%S'),
        endDatetime: time.dateToStr(end, '%Y-%m-%d %H:%M:%S')
      }
      this.loadSummary()
    },
    async loadOrganizations () {
      const options = []
      const size = 200
      for (let page = 1; ; page++) {
        const res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination: {page, rowsPerPage: size}, name: '', id: '', type: 'org'
        })
        if (res.data.status !== 1) throw new Error(res.data.msg || '查询单位失败')
        const data = res.data.data
        options.push(...data.content.map(org => ({id: org.id, name: org.name})))
        if (page * size >= data.totalElements || !data.content.length) break
      }
      this.orgOptions = options
    },
    async loadSummary () {
      const version = ++this.queryVersion
      const start = time.toTimeStamp(this.period.startDatetime)
      const end = time.toTimeStamp(this.period.endDatetime)
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000) {
        this.loading = false
        this.summary = []
        this.selected = null
        this.$L.alert('error', {message: '请选择不超过93天的违章时间段'})
        return
      }
      this.loading = true
      this.selected = null
      this.summary = []
      try {
        const request = {
          startTime: time.dateToStr(new Date(start), '%Y-%m-%d %H:%M:%S'),
          endTime: time.dateToStr(new Date(end), '%Y-%m-%d %H:%M:%S')
        }
        if (this.selectedOrgId) request.orgId = this.selectedOrgId
        const rows = await this.$store.dispatch('violation/getAppointmentOrgSummary', request)
        if (version !== this.queryVersion) return
        if (!Array.isArray(rows)) throw new Error('统计接口返回格式错误')
        this.request = request
        this.summary = rows
      }
      catch (error) {
        if (version === this.queryVersion) this.$L.alert('error', {message: '统计查询失败：' + error.message})
      }
      finally {
        if (version === this.queryVersion) this.loading = false
      }
    },
    selectOrg (row) {
      this.selected = row
      this.objectCode = ''
      this.appliedObjectCode = ''
    },
    applyPlate () {
      this.appliedObjectCode = (this.objectCode || '').trim()
      this.$refs.details.refresh(true)
    },
    async getDetails ({pagination}) {
      const data = await this.$store.dispatch('violation/getAppointmentOrgDetails', {
        request: {
          ...this.request,
          orgId: this.selected.orgId,
          objectCode: this.appliedObjectCode || undefined
        },
        pagination
      })
      if (!data || !Array.isArray(data.content)) throw new Error('明细接口返回格式错误')
      return {items: data.content.map(row => ({...row, description: this.description(row.handlingResult)})), amount: data.totalElements}
    },
    description (value) {
      try {
        const details = JSON.parse(value || '{}')
        return details.msg || ''
      }
      catch (error) {
        return value || ''
      }
    },
    exportRequest () {
      const start = time.toTimeStamp(this.period.startDatetime)
      const end = time.toTimeStamp(this.period.endDatetime)
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000 ||
        !this.request || this.request.startTime !== time.dateToStr(new Date(start), '%Y-%m-%d %H:%M:%S') ||
        this.request.endTime !== time.dateToStr(new Date(end), '%Y-%m-%d %H:%M:%S')) {
        this.$L.alert('error', {message: '请先选择不超过93天的时间范围并查询'})
        return null
      }
      return this.request
    },
    exportSummary () {
      if (!this.exportRequest()) return
      const ExportJsonExcel = require('js-export-excel')
      new ExportJsonExcel({
        fileName: '单位预约违章统计',
        datas: [{
          sheetName: '单位汇总',
          sheetHeader: ['预约人二级单位', '违章次数', '去重车牌数'],
          sheetData: this.summaryRows.map(row => [row.orgName, row.violationCount, row.vehicleCount])
        }]
      }).saveExcel()
    },
    async exportDetails () {
      if (!this.selected || !this.exportRequest()) return
      await this.exportDetailRows([this.selected], this.appliedObjectCode, '单位预约违章清单')
    },
    async exportAllDetails () {
      const current = this.exportRequest()
      if (!current || this.exporting) return
      this.exporting = true
      try {
        const periodRequest = {startTime: current.startTime, endTime: current.endTime}
        const summary = await this.$store.dispatch('violation/getAppointmentOrgSummary', periodRequest)
        if (!Array.isArray(summary)) throw new Error('统计接口返回格式错误')
        const names = new Map(this.orgOptions.map(org => [org.id, org.name]))
        const groups = summary.filter(row => row.orgId).map(row => ({
          ...row, orgName: names.get(row.orgId) || row.orgId
        }))
        await this.writeDetailRows(groups, periodRequest, '', '全部单位预约违章清单')
      }
      catch (error) {
        this.$L.alert('error', {message: '导出失败：' + error.message})
      }
      finally {
        this.exporting = false
      }
    },
    async exportDetailRows (groups, objectCode, fileName) {
      if (this.exporting || !groups.length) return
      this.exporting = true
      try {
        await this.writeDetailRows(groups, this.request, objectCode, fileName)
      }
      catch (error) {
        this.$L.alert('error', {message: '导出失败：' + error.message})
      }
      finally {
        this.exporting = false
      }
    },
    async writeDetailRows (groups, periodRequest, objectCode, fileName) {
      if (!groups.length) throw new Error('当前时间范围内没有可导出的违章记录')
      const rows = []
      const size = 200
      for (const selection of groups) {
        const request = {...periodRequest, orgId: selection.orgId, objectCode: objectCode || undefined}
        for (let page = 1; ; page++) {
          const data = await this.$store.dispatch('violation/getAppointmentOrgDetails', {
            request, pagination: {page, rowsPerPage: size}
          })
          if (!data || !Array.isArray(data.content)) throw new Error('明细接口返回格式错误')
          rows.push(...data.content.map(row => [
            selection.orgName, row.objectCode, row.violationTime, row.viogrpId,
            row.interviewerId, this.description(row.handlingResult)
          ]))
          if (page * size >= data.totalElements || !data.content.length) break
        }
      }
      if (!rows.length) throw new Error('当前时间范围内没有可导出的违章记录')
      const ExportJsonExcel = require('js-export-excel')
      new ExportJsonExcel({
        fileName,
        datas: [{
          sheetName: '违章清单',
          sheetHeader: ['预约人二级单位', '车辆号牌', '违章时间', '违章类型 ID', '预约人 ID', '违章详情'],
          sheetData: rows
        }]
      }).saveExcel()
    },
    goDetails ({item}) {
      if (!document.getSelection().toString()) {
        this.$router.push({
          name: 'ViolationEventDetails',
          params: {plate: item.objectCode},
          query: {id: item.id, history: true}
        })
      }
    }
  },
  created () {
    this.setPreset(7)
    this.loadOrganizations().catch(error => this.$L.alert('error', {message: '单位列表加载失败：' + error.message}))
  }
}
</script>

<style scoped>
.stats-toolbar, .stats-filters, .stats-commands {
  display: flex;
  align-items: center;
}
.stats-toolbar {
  flex-wrap: wrap;
  gap: 8px;
}
.stats-filters {
  margin: 8px 0 16px;
}
.stats-commands {
  flex-wrap: wrap;
}
.period-presets {
  max-width: 100%;
}
.plate-search {
  max-width: 180px;
}
</style>
